import { createClient } from '@supabase/supabase-js';
import type { BrowserEnv } from '../config/env';
import type { Database } from './database.types';

export function createBrowserSupabaseClient(env: BrowserEnv) {
  return createClient<Database>(
    env.VITE_SUPABASE_URL,
    env.VITE_SUPABASE_PUBLIC_KEY,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    },
  );
}

export type AdultSessionProvider = {
  getAdultAccessToken(): Promise<string | null>;
};
export type LearnerGrantProvider = {
  getShortLivedLearnerGrant(): Promise<string | null>;
};
